import { styled } from '@clickcease/cc-client-components-lib'

export const StyledPendingInvitations = styled('div', {})

export const StyledPendingInvitationsTitleButton = styled('button', {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
})

export const StyledPendingInvitationsToastWrapper = styled('div', {
  paddingRight: '40px',
  paddingTop: '10px',
})

export const StyledPendingInvitationsSubtitle = styled('p', {
  marginTop: '8px',
  fontSize: '14px',
})

export const StyledPendingInvitationsTable = styled('table', {
  minWidth: '500px',
  minHeight: '20px',
  padding: '20px',
  borderCollapse: 'collapse',
})

export const StyledPendingInvitationsActions = styled('div', {
  marginTop: '16px',
  display: 'flex',
  justifyContent: 'flex-end',
})

export const StyledPendingInvitationsModalWrapper = styled('div', {
  padding: '20px',
  fontWeight: '$l',
  fontSize: '14px',
})

export const StyledPendingInvitationsTableRow = styled('tr', {
  display: 'flex',
  marginBottom: '10px',
  '&:hover': {
    backgroundColor: '$tableSelected',
  },
})

export const StyledPendingInvitationsTableBody = styled('tbody', {})

export const StyledPendingInvitationsTableCell = styled('td', {
  display: 'flex',
  gap: '20px',
  alignItems: 'center',
})

export const ReAuthModalBodyWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  padding: '20px',
})

export const ButtonWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
})

export const ErrorWrapper = styled('div', {
  color: 'red',
  fontSize: '$md',
})
